import {
	Helpers,
	IRuleType,
	RuleEngineEntities,
	RuleEngineLegacyEntities,
	RuleType
} from '@bimser/components/dist/BCRuleManager';
import { IDictionary } from '@bimser/core';
import { Map } from 'immutable';
import { IRuleTriggerEventItem } from '../environments/runtime/components/Form/entities';

export function getTriggeredRules(
	rules: IDictionary<IRuleType>,
	eventItem: IRuleTriggerEventItem
): Map<string, RuleType> {
	let filteredRules: Map<string, RuleType> = Map();

	for (const ruleId in rules) {
		const rule = rules[ruleId];
		const ruleFound = rule.triggerEvents.some(
			event => event === `${eventItem.controlId}.client.${eventItem.eventName}`
		);

		if (ruleFound) {
			if (Helpers.isLegacyRule(rule)) {
				filteredRules = filteredRules.set(
					rule.id,
					RuleEngineLegacyEntities.RuleFactoryFromJS(rule)
				);
			} else {
				filteredRules = filteredRules.set(
					rule.id,
					RuleEngineEntities.RuleFactoryFromJS(rule)
				);
			}
		}
	}

	return filteredRules;
}
